module.exports = "<p *ngIf=\"questionnaire && questionnaire.submitDate\" class=\"lime-label text-semi-bold mb-15\">\n    Answers submitted\n    <span class=\"lime-label\" *ngIf=\"questionnaire.showOptInConsent\">\n        {{ questionnaire.optInConsent ? 'with' : 'without' }} opt-in consent\n    </span>\n    on {{ questionnaire.submitDate| timeFilter: 'long' }}\n</p>"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/questionnaire-submitted-statement/questionnaire-submitted-statement.html
// module id = ./shared/components/common/questionnaire-submitted-statement/questionnaire-submitted-statement.html
// module chunks = 0